import clsx from 'clsx'
import React from 'react'

interface ButtonProps {
  onClick?: () => void
  disabled?: boolean
  className?: string
  children?: React.ReactNode
  icon?: React.ReactNode
  variant?: 'primary' | 'secondary' | 'success' | 'danger'
  size?: 'sm' | 'md' | 'lg'
}

export default function Button({
  onClick,
  disabled = false,
  className = '',
  children = '导出模板',
  icon = undefined,
  variant = 'primary',
  size = 'md'
}: ButtonProps) {
  const buttonClasses = clsx(
    // 基础样式
    'inline-flex items-center font-medium rounded-md',
    'disabled:opacity-50 disabled:cursor-not-allowed',
    'focus:outline-none focus:ring-2 transition-colors',

    // 变体样式
    {
      'text-white bg-blue-600 hover:bg-primary-700 focus:ring-primary-500':
        variant === 'primary',
      'text-gray-700 bg-gray-200 hover:bg-secondary-300 focus:ring-secondary-500':
        variant === 'secondary',
      'text-white bg-green-600 hover:bg-green-700 focus:ring-green-500':
        variant === 'success',
      'text-white bg-red-600 hover:bg-red-700 focus:ring-red-500':
        variant === 'danger'
    },

    // 尺寸样式
    {
      'px-3 py-1.5 text-xs': size === 'sm',
      'px-4 py-2 text-sm': size === 'md',
      'px-6 py-3 text-base': size === 'lg'
    },

    // 自定义样式
    className
  )

  return (
    <button onClick={onClick} disabled={disabled} className={buttonClasses}>
      {icon} {children}
    </button>
  )
}
